<template>
  <div class="login-page">
    <section class="login-section">
      <div class="login-container">
        <div class="login-card">
          <div class="login-card__top-image">
            <div class="login-card__top-image__overlay"></div>
            <div class="login-card__top-image__content">
              <h1>Zaloguj się do serwisu</h1>
              <p>Zarządzaj kontem, usługami i ogłoszeniami w jednym miejscu.</p>
            </div>
          </div>

          <div class="login-card__body">
            <div class="login-card__image-aside">
              <img src="@/assets/pies.png" alt="">
            </div>

            <div class="login-card__form">
              <Form @submit="handleLogin" :validation-schema="schema">
                <div class="form-group">
                  <label for="login">Login</label>
                  <Field name="login" type="text" class="form-control" autocomplete="email"/>
                  <ErrorMessage name="login" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="password">
                    Hasło
                    <span role="button" class="show-hide-pass" @click="() => showPass = !showPass">
                      {{ showPass ? 'ukryj' : 'pokaż' }}
                    </span>
                  </label>
                  <Field name="password" :type="showPass ? 'text' : 'password'" class="form-control" autocomplete="current-password"/>
                  <RouterLink class="reset-pass" to="/login/reset">Nie pamiętam hasła</RouterLink>
                  <ErrorMessage name="password" class="error-feedback" />
                </div>

                <div class="form-group">
                  <button class="submit-btn" :disabled="loading">
                    <span v-show="loading" class="spinner-border"></span>
                    <span>Zaloguj się</span>
                  </button>
                </div>

                <div class="form-group">
                  <div v-if="message" class="alert alert-danger" role="alert">
                    {{ message }}
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from 'yup';
import { useMeta } from 'vue-meta';
import { RouterLink } from "vue-router";
import { useAuthStore } from "@/stores/auth";

export default {
  name: "LoginPage",
  setup () {
    useMeta({
      title: 'Zaloguj się',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    });

    return {
      authStore: useAuthStore(),
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    RouterLink
  },
  data() {
    const schema = yup.object().shape({
      login: yup.string().required("login jest wymagany!"),
      password: yup.string().required("hasło jest wymagane!"),
    });

    return {
      loading: false,
      message: "",
      schema,
      showPass: false
    };
  },
  computed: {
    loggedIn() {
      return this.authStore.loggedIn;
    },
    user() {
      return this.authStore.user;
    }
  },
  created() {
    if (this.loggedIn) {
      const user = this.user;
      if (user.role_id === 3) {
        this.$router.push(`/profile`);
      } else if (user.role_id === 2) {
        this.$router.push(`/dla-biznesu/profile`);
      } else if (user.role_id === 4) {
        this.$router.push(`/dla-biznesu/employee-profile`);
      } else if (user.role_id === 1) {
        this.$router.push(`/admin-profile`);
      } else if (user.role_id === 5) {
        this.$router.push('/firm-profile');
      }
    }
  },
  methods: {
    handleLogin(user) {
      this.loading = true;
      this.message = "";

      this.authStore.login(user).then(
          () => {
            if (this.user.role_id === 3) {
              this.$router.push(`/profile`);
            } else if (this.user.role_id === 2) {
              this.$router.push(`/dla-biznesu/profile`);
            } else if (this.user.role_id === 4) {
              this.$router.push(`/dla-biznesu/employee-profile`);
            } else if (this.user.role_id === 1) {
              this.$router.push(`/admin-profile`);
            } else if (this.user.role_id === 5) {
              this.$router.push('/firm-profile');
            }
          },
          () => {
            this.loading = false;
            this.message = "Nieprawidłowy login lub hasło.";
          }
      );
    },
  },
};
</script>

<style lang="scss">
.login-page{
  min-height: calc(100vh - 160px);
}

.login-section{
  padding: 28px 0 40px;
}

.login-container{
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}

.login-card{
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 15px 40px rgba(0,0,0,.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &__top-image{
    position: relative;
    min-height: 200px;
    background-image: url('https://images.unsplash.com/photo-1583337130417-3346a1be7dee?q=80&w=1920&auto=format&fit=crop');
    background-size: cover;
    background-position: center;

    &__overlay{
      position: absolute;
      inset: 0;
      background: rgba(31, 41, 55, .68);
    }

    &__content{
      position: relative;
      z-index: 1;
      color: #fff;
      padding: 28px 24px;

      h1{
        margin: 0 0 8px;
        font-size: clamp(2.6rem, 4vw, 4rem);
        line-height: 1.2;
      }

      p{
        margin: 0;
        font-size: 1.7rem;
        color: #e5e7eb;
      }
    }
  }

  &__body{
    display: grid;
    grid-template-columns: 320px 1fr;
  }

  &__image-aside{
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;

    img{
      width: 100%;
      max-width: 220px;
      object-fit: contain;
    }
  }

  &__form{
    padding: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    form{
      width: 100%;
      max-width: 460px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
}

.form-group{
  display: flex;
  flex-direction: column;
  gap: 8px;

  label{
    font-size: 1.5rem;
    color: #374151;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.form-control{
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 1.6rem;
  color: #1f2937;
  box-sizing: border-box;
  transition: border-color .2s ease, box-shadow .2s ease;
}
.form-control:focus{
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 1px #10b981;
}

.submit-btn{
  margin-top: 6px;
  background: #10b981;
  color: #fff;
  border: none;
  border-radius: 8px;
  min-height: 46px;
  padding: 0 18px;
  font-size: 1.6rem;
  font-weight: 700;
  cursor: pointer;
  transition: .2s;
}
.submit-btn:hover{
  background: #059669;
}
.submit-btn:disabled{
  opacity: .7;
  cursor: not-allowed;
}

.show-hide-pass{
  text-decoration: underline;
  cursor: pointer;
  color: #6b7280;
  font-size: 1.4rem;
}

.reset-pass{
  margin-top: 2px;
  text-decoration: none;
  font-size: 1.4rem;
  color: #10b981;
}
.reset-pass:hover{
  text-decoration: underline;
}

.error-feedback{
  color: #dc2626;
  font-size: 1.3rem;
}

.alert-danger{
  color: #dc2626;
  font-size: 1.4rem;
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}

.spinner-border {
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: text-bottom;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
  margin-right: 10px;
}

@media(max-width: 900px){
  .login-card{
    &__body{
      grid-template-columns: 1fr;
    }
    &__image-aside{
      display: none;
    }
    &__form{
      padding: 20px;
    }
  }
}
</style>